module.exports = __webpack_public_path__ + "static/media/gw.84a72098.png";